export var Params={
    //url_api: 'http://10.150.10.13:9999/api',
    url_api: 'https://api.cossmil.mil.bo/api',
    authorization: 'Authorization',
    bearer: 'Bearer ',
    key: 'myK3y&77?98766@%$'
}